import React from 'react';
import _ from 'lodash';
import themeData from './themes.json'
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../../common/components/form/input/containers/input.container';

export const BrandMappingBasicInfoComponent = ({ webpages, websites,
  brandMappings, onFormItemBrandChange,
}: any) => {

  return (
    <>
      {_.map(brandMappings, (selectedBrand: any, index: any) => (
        <AccordionContainer
          child={
            <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <InputContainer
                label="Name"
                labelField="Name"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'Name',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.Name} />
              <InputContainer
                label="Description"
                labelField="Description"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'Description',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.Description}
              />
              {themeData &&
                <InputContainer
                  label="Theme"
                  labelField="Text"
                  list={themeData}
                  onValueChange={(event: any, newValue: any) => {
                    onFormItemBrandChange({
                      value: event.target.value,
                      field: 'Theme',
                      idx: index
                    });
                  }}
                  optionName='Choose Theme'
                  type="select"
                  value={selectedBrand?.Theme}
                  valueField="Value"
                />

              }


            </div>
          }
          expandedPanel="BrandMappings"
          headerTitle="Brand Mappings"
        />
      )
      )}
    </>
  )
}

export default BrandMappingBasicInfoComponent;
